var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBandaconectada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_11456",
    "data-name": "Grupo 11456",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.921,
    height: 71.921,
    viewBox: "0 0 71.921 71.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6579",
    "data-name": "Grupo 6579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_191",
    "data-name": "Elipse 191",
    cx: 35.96,
    cy: 35.96,
    r: 35.96,
    fill: "#9eaced"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11204",
    "data-name": "Grupo 11204",
    transform: "translate(17.953 21.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7602",
    "data-name": "Grupo 7602",
    transform: "translate(4.423 4.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7601",
    "data-name": "Grupo 7601",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5053",
    "data-name": "Trazado 5053",
    d: "M-2542.543,533.107a9,9,0,0,1,1.2-2.849,6.822,6.822,0,0,1,7.1-2.829,6.8,6.8,0,0,1,5.209,5.44,8.958,8.958,0,0,1-1,5.465,22.987,22.987,0,0,1-5.439,7.01,44.664,44.664,0,0,1-6.7,5.008c-.183.114-.328.2-.569.053a39.786,39.786,0,0,1-9.229-7.583,17.3,17.3,0,0,1-3.752-6.5,6.875,6.875,0,0,1,3.111-8.176,6.8,6.8,0,0,1,10.025,4.72C-2542.574,532.947-2542.558,533.027-2542.543,533.107Z",
    transform: "translate(2556.051 -527.264)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandaconectada);
export default __webpack_public_path__ + "static/media/BANDACONECTADA.eb4a90d538b572f306e4db70582d1b8f.svg";
export { ForwardRef as ReactComponent };